import React from 'react';
import styled from 'styled-components';
import {TextField as MuiTextField} from '@material-ui/core';
import property from 'lodash/property';
import {mdDownN, xsDown} from "../../../common";

const StyledTextField = styled(MuiTextField)`
    &.MuiFormControl-root {
        width: 100%;

        .MuiFormLabel-root {
            color: ${property('theme.color.tertiary90')};
            font-family: ${property('theme.typography.text.fontFamily')};
        }

        .Mui-focused {
            color: ${property('theme.color.primary')};
        }

        .MuiInputBase-root {
            border-radius: 0;
            background-color: ${property('theme.color.grey30')};
            color: ${property('theme.color.black')};
            font-family: ${property('theme.typography.text.fontFamily')};
            font-weight: ${property('theme.typography.text.fontWeight.medium')};
        }

        .MuiFilledInput-underline::before {
            border-bottom-color: ${property('theme.color.tertiary90')};
        }

        .MuiFilledInput-underline::after {
            border-bottom-color: ${property('theme.color.secondary')};
        }

        .MuiFormHelperText-root {
            margin-top: 0;
            padding: 8px 0 0;
            color: ${property('theme.color.tertiary90')};
            font-family: ${property('theme.typography.text.fontFamily')};
        }
    }

    .MuiFormLabel-root.Mui-error,
    .MuiFormHelperText-root.Mui-error {
        color: ${property('theme.color.error')};
    }

    .MuiInput-underline.Mui-error::after {
        border-bottom-color: ${property('theme.color.error')};
    }
    ${mdDownN`
        .MuiFormHelperText-root,
        .MuiFormHelperText-root.Mui-error{
            overflow-wrap: break-word;
            width: 85%!important;
            max-width: calc(100vw - 80px);
            overflow: hidden;
            margin-left:0;
            margin-right:0;
            padding-left:14px!important;
        }
        .MuiInputLabel-filled{
          font-family: Inter-Regular;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 24px;
          text-align: left;
          color: #003DA5;
        }
        .MuiFormLabel-filled{
            color: #003DA5!important;
            font-family: Inter-Medium;
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 18px;
        }
        .MuiFormLabel-filled.Mui-error{
            color: #f44336!important;
        }
        
        .Mui-error .MuiInputAdornment-positionEnd{
            display:none;
        }
        
        .MuiInputLabel-filled.Mui-focused{
          font-family: Inter-Medium;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 18px;
        }

        .MuiFilledInput-underline:before {
            border-bottom: 2px solid #455571!important;
        }
        
        .MuiFilledInput-underline.Mui-error:before {
            border-bottom: 2px solid transparent!important;
        }
        .MuiFilledInput-underline.Mui-error:after {
            border-bottom: 2px solid #f44336!important;
        }
        .MuiFilledInput-input{
          font-family: Inter-Medium;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 24px;
        }
    `}
    ${xsDown`
        .MuiInputLabel-filled{
          font-size: 14px;
        }
    `}
`;

const TextField = React.forwardRef((props, ref) => (
    <StyledTextField
        {...props}
        inputRef={ref}
    />
));

TextField.displayName = 'TextField';

export default TextField;
